const $ = jQuery.noConflict();

class Slider {
    constructor(selector, args = {}) {
        this.selector = selector;
        this.args = args;
    }

    getDefaultSlickSettings() {
        return {
            dots: false,
            arrows: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            pauseOnHover: false,
            speed: 600,
        }
    }

    /**
     * Override our default slick settings with args provided to the class.
     */
    getSlickSettings() {
        return Object.assign({}, this.getDefaultSlickSettings(), this.args);
    }

    init() {
        if ($(this.selector).length > 0) {
            $(this.selector).on('setPosition', () => {
                $(this.selector).find('figcaption').each((i, item) => {
                    const caption = $(item);
                    const width = caption.closest('figure').find('img').width();
                    caption.css('max-width', width > 0 ? `${width}px` : '');
                });
            });

            let settings = this.getSlickSettings();

            $(this.selector).slick(settings);
        }
    }
}

const SimpleSlider = new Slider('.gallery-slider__slider');
const TestimonialSlider = new Slider('.testimonial-slider');
const FluidSlider = new Slider(
    '.gallery-slider__slider-fluid',
    {
        centerMode: true,
        variableWidth: true,
    }
);

const GalleryProgressSlider = new Slider(
    '.gallery-slider__slider-fluid-progress',
    {
        centerMode: true,
        variableWidth: true,
        dots: true,
        arrows: true,
    }
);

const ImageLinkSlider = new Slider(
    '.block-image-link-slider__images',
    {
        centerMode: true,
        variableWidth: true,
        arrow: true,
        dots: true,
		waitForAnimate: false,
    }
);

const FeaturedExperiences = new Slider(
    '.block-featured-experience__cards',
    {
        variableWidth: true,
        arrow: true,
        dots: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 991,
                settings: 'unslick',
            },
        ],
    }
);

const HeroSlider = new Slider(
    '.page-hero__image-wrapper--slider',
    {
        arrows: false,
        dots: true,
    }
);

const AccommodationSlider = new Slider(
    '.block-accommodation-card__slider',
    {
        arrows: true,
        dots: false,
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
    }
);

const AccommodationSliderRelated = new Slider(
    '.accommodation-card__slider',
    {
        arrows: true,
        dots: true,
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
    }
);

const AcccomodationHeroSlider = new Slider(
    '.single-accommodation-hero__slider',
    {
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        autoplay: true,
        autoplaySpeed: 5000,
    }
);

const CulinaryRelatedSlider = new Slider(
    '.culinary-card__slider',
    {
        arrows: true,
        dots: true,
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
    }
);

const VenueRelatedSlider = new Slider(
    '.venue-card__slider',
    {
        arrows: true,
        dots: false,
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
    }
);

const ContentImageSlider = new Slider(
    '.block-content-image-slider__slider',
    {
        arrows: false,
        dots: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        variableWidth: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    arrows: true
                },
            },
        ],
    }
);

const BrandsSlider = new Slider(
    '.block-brands-gallery__slider',
    {
        arrows: true,
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 1,
		responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                },
            },
			{
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                },
            },
        ],
    }
);

export { SimpleSlider, TestimonialSlider, FluidSlider, ImageLinkSlider, FeaturedExperiences, HeroSlider, AccommodationSlider, GalleryProgressSlider, AcccomodationHeroSlider, AccommodationSliderRelated, CulinaryRelatedSlider, VenueRelatedSlider, ContentImageSlider, BrandsSlider };
